/* eslint-disable no-unused-vars */
import firehydrantAPI from 'helpers/firehydrantAPI';

import tasklistsFactory from 'components/TaskManagement/factories/tasklists.factory';

import {
  createMutationHook,
  useDetailQuery,
  useListQuery,
} from '../common/index';

const RESOURCE_NAME = 'task_lists';
const RESOURCE = [{ resource: RESOURCE_NAME }];

export const useTaskLists = (params = {}, options = {}) => {
  const requestParams = { params: { per_page: 20, ...params } };
  return useListQuery(
    RESOURCE,
    requestParams,
    () => firehydrantAPI.get(RESOURCE_NAME, requestParams),
    options,
  );
};

export const useTaskList = (params = {}, options = {}) => {
  return useDetailQuery(
    RESOURCE,
    params.id,
    () => firehydrantAPI.get(`${RESOURCE_NAME}/${params.id}`),
    { enabled: !!params.id && params.id !== 'new', ...options },
  );
};

const createTaskList = (params) => firehydrantAPI.post(RESOURCE_NAME, params);
export const useCreateTaskList = createMutationHook(createTaskList);

const deleteTaskList = (params) =>
  firehydrantAPI.delete(`${RESOURCE_NAME}/${params.id}`, params);
export const useDeleteTaskList = createMutationHook(deleteTaskList);

const updateTaskList = (params) =>
  firehydrantAPI.patch(`${RESOURCE_NAME}/${params.id}`, params);

export const useUpdateTaskList = createMutationHook(updateTaskList);
